// src/api/auth.ts
import { csrfFetch } from "./csrf";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.wbl-dartliga.de/api"
    : import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api";

export async function adminLogin(username: string, password: string) {
  const response = await csrfFetch(
    `${API_BASE_URL.replace(/\/$/, "")}/users/admin-login/`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || "Login fehlgeschlagen");
  }

  return response.json(); // Should contain token and optionally user info
}

export const confirmAuth = async () => {
  const token = sessionStorage.getItem("adminToken");
  if (!token) return;
  const url = `${API_BASE_URL.replace(/\/$/, "")}/users/admin-login`;

  const response = await csrfFetch(`${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response);
  // if (!token) throw new Error("No token found");

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || "Login fehlgeschlagen");
  }

  return response.json(); // Should contain token and optionally user info
};
